export default "__VITE_PUBLIC_ASSET__d42ebe12__"